import { render, staticRenderFns } from "./CalendarInfoBar.vue?vue&type=template&id=0158e357&"
import script from "./CalendarInfoBar.vue?vue&type=script&lang=js&"
export * from "./CalendarInfoBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports